// extracted by mini-css-extract-plugin
export default {"header":"styles_header__lm1EH","buttonPosition":"styles_buttonPosition__+ieQw","avatar":"styles_avatar__5DpdX"};